export const OPTION_ITEM_HEIGHT = 36;
export const NON_OPTION_ITEM_HEIGHT = 30;
export const OPTION_ITEM_HEIGHT_WITH_DESCRIPTION = 50;
